import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  estateTaskDataGrid: {
    '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
      display: 'none',
    },
    '& .estateTasksHeader': {
      backgroundColor: '#F5F5F5',
    },
    '& .checkbox-column': {
      backgroundColor: '#F5F5F5',
    },
    width: '100%',
    border: 'none',
  },
  container: {
    width: '100vw',
  },
  heading: {
    fontWeight: 'bold',
    paddingBottom: theme.spacing(3),
  },
}));
